<template lang="pug">
div.dropdown
    span(id="bell-dropdown-top-right").icon-dropdown.mr-3
      b-icon.h4.mt-1.bell-icon(
        id="popover-1-bottomleft", @click="getNotifications" :class="{'shake' : animated}", href="#", style="cursor: pointer;", tabindex="0", variant="info" icon="bell-fill")
    div(
      v-if="newOT > 0"
    ).popover-notifications.d-flex.align-items-center.justify-content-center {{newOT}}
    b-popover.popover(
      target="popover-1-bottomleft"
      triggers="click"
      placement="bottomleft"
      custom-class="custom-notifications-popover"
    )
      ul(@scroll="handleScroll").dropdown-content.scroll
        li.title-notifications.dropdown-item
          .d-flex.flex-column.mb-2
            .d-flex.align-items-center.justify-content-between.mb-3
              span.mr-4.font-notification Notificaciones
              b-icon.h3.mb-0.close-icon(icon="x", @click.stop="closeNotifications")
            .w-100
              b-select(
                :options="actionsAvailable"
                size="sm"
                v-model="optionActionSelected"
                placeholder="Seleccione una acción"
                @change="handleSelectedAction"
                class="custom-select-full"
              )
                option(value="") Todos
          .tabs-container.mt-2
            .d-flex.align-items-center.gap-16
              .tab-item(:class="{'active': serviceTypeSelected === ''}" @click="selectServiceType('')")
                span Todos
              .tab-item(:class="{'active': serviceTypeSelected === 4}" @click="selectServiceType(4)")
                span Presupuestos
              .tab-item(:class="{'active': serviceTypeSelected === 1}" @click="selectServiceType(1)")
                span Garantías
        hr.dropdown-divider.m-0
        li(v-if="notificationsOTS" v-for="otNotification in OTList").dropdown-item.p-0
          .notification-item.separator-notification-item.px-3.py-2
            .d-flex.align-items-center.w-100
              //- Left side: Date and Time
              .date-container.mr-4
                .date-text {{ formatDateDay(otNotification.created_at) }}
                .time-text {{ formatDateTime(otNotification.created_at) }}
              //- Right side: OT and Action
              .content-container.flex-grow-1
                .ot-text
                  span.bold OT {{ otNotification.ot }}
                router-link(:to="`/orden/${otNotification.ot}`" target="_blank").action-link
                  span.action-text {{ otNotification.action[1] }}
        li(v-if="loading").dropdown-item
          b-skeleton(type="text" animation="fade" width="100%")
          b-skeleton(type="text" animation="fade" width="100%")
          b-skeleton(type="text" animation="fade" width="20%")
          hr
</template>
<script>
import { io } from 'socket.io-client'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { showButton } from '@/utils/actionsConditions'
import settings from '@/../settings'

export default {
  data() {
    return {
      animated: true,
      tolerance: 10, // px
      newOT: 0,
      actions: [
        ['Diagnosticar', 'Diagnosticar'],
        ['RevisarInforme', 'Revisar Informe'],
        ['EnviarCorreoCambio', 'Enviar correo de cambio'],
        ['EsperaDeRetiro', 'Espera de retiro'],
        ['EditRMA', 'Editar RMA'],
        ['SelectTechnician', 'Selección técnico'],
        ['PrimerIngresoABodega', 'Primer ingreso a bodega'],
        ['EntregarTecnico', 'Entregar a tecnico para diagnostico'],
        ['EntregarTecnicoReparacion', 'Entregar a tecnico para reparación'],
        ['IngresarABodega', 'Ingresar a bodega'],
        ['IngresarABodegaRechazado', 'Ingresar a bodega rechazado'],
        [
          'IngresarABodegaPorEsperaDePartes',
          'Ingresar A Bodega Por Espera DePartes',
        ],
        [
          'EntregarEquipoRepuestoLocalizado',
          'Entregar equipo repuesto localizado',
        ],
        ['IngresarABodegaReparado', 'Ingresar a bodega reparado'],
        ['DarSalida', 'Dar salida'],
        ['Rechazar', 'Rechazar'],
        ['IngresarReparacion', 'Ingresar reparacion'],
        ['SolicitarPartes', 'Solicitar partes'],
        ['LlegadaDePartes', 'Llegada de partes'],
        ['CompletPreIngreso', 'Completar preingreso'],
        ['InternalQuotation', 'Cotización interna'],
        ['Reingreso', 'Reingreso'],
        ['EntregarRecepcion', 'Entregar a recepcion'],
        ['AddBoleta', 'Añadir boleta'],
        ['Cambio3x3', 'Cambio 3x3'],
        ['DiagnosticadoPorRevisar', 'Diagnosticado por revisar'],
        ['EntregarEquipoCliente', 'Entregar equipo al cliente'],
        ['DevolverBodega', 'Devolver a bodega'],
        ['RevisarDiagnostico', 'Revisar Diagnostico'],
        ['CambioEsperaDeParte', 'Cambio por espera de parte'],
        ['DesarmarEquipo', 'Desarmar equipo'],
        ['EntregarClienteTienda', 'Entregar a cliente por tienda'],
        ['EntregarTecnicoSinPartes', 'Entregar a técnico sin partes'],
        ['RechazarPreIngreso', 'Rechazar pre-ingreso'],
        ['RechazoAdministrativo', 'Rechazo administrativo'],
        ['RecibirEquipo', 'Recibir equipo'],
        ['RevaluarOT', 'Revaluar OT'],
      ],
      OTList: [],
      loading: false,
      currentPage: 1,
      optionActionSelected: '',
      fullLoader: false,
      stopFetch: false,
      previousOptionActionSelected: '',
      actionsAvailable: [],
      serviceTypeSelected: '',
      serviceTypeOptions: [
        { value: '', text: 'Todos' },
        { value: 1, text: 'Garantía' },
        { value: 4, text: 'Presupuesto' },
      ],
    }
  },
  async created() {
    this.initWebsockets()
  },
  methods: {
    ...mapActions('OT', ['listNotificationsPagination', 'searchOT']),
    showButton: (actionName, ot, user) => showButton(actionName, ot, user),
    async handleScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (
        scrollTop + clientHeight >= scrollHeight - this.tolerance &&
        !this.loading &&
        !this.optionActionSelected &&
        !this.serviceTypeSelected
      ) {
        this.currentPage += 1
        await this.loadMoreNotifications(
          this.currentPage,
          this.optionActionSelected,
          this.serviceTypeSelected
        )
      }
    },
    async handleSelectedAction() {
      this.OTList = []
      this.loading = true
      if (
        this.currentPage === 1 &&
        this.optionActionSelected === '' &&
        this.serviceTypeSelected === ''
      ) {
        await this.getNotifications()
      } else {
        this.stopFetch = true
        await this.fetchAllNotifications(
          this.optionActionSelected,
          this.serviceTypeSelected
        )
      }
    },
    async fetchAllNotifications(optionActionSelected, serviceTypeSelected) {
      let page = 1
      try {
        while (this.stopFetch) {
          if (this.fullLoader) {
            // Cuando no haya mas resultados en la peticion
            return
          }
          // Verifica si la selección ha cambiado. Si es así, sale del ciclo.
          if (this.optionActionSelected !== optionActionSelected) {
            this.stopFetch = false
            return
          }
          // eslint-disable-next-line no-await-in-loop
          const res = await this.listNotificationsPagination({
            page,
            action: optionActionSelected,
            tipo_servicio: serviceTypeSelected,
          })

          if (res.status < 200 || res.status >= 300) {
            this.fullLoader = true
            return
          }
          res.data.results.forEach((ot) => {
            if (ot.acciones == null) return
            ot.acciones.forEach((action) => {
              if (optionActionSelected && action !== optionActionSelected) {
                return
              }

              const actionObject = this.actions.find((a) => a[0] === action)
              if (!actionObject) return
              this.OTList.push({
                ot: ot.ot_id,
                action: actionObject,
                created_at: ot.created_at,
              })
              this.loading = false
            })
          })

          this.stopFetch = !!res.data.next
          page += 1
        }
      } catch (error) {
        console.error('Error al cargar todas las notificaciones:', error)
      } finally {
        this.loading = false
      }
    },
    async loadMoreNotifications(
      page,
      optionActionSelected,
      serviceTypeSelected
    ) {
      try {
        if (this.fullLoader) {
          return
        }
        const res = await this.listNotificationsPagination({
          page,
          action: optionActionSelected,
          tipo_servicio: serviceTypeSelected,
        })
        if (res.status < 200 || res.status >= 300) {
          this.fullLoader = true
          return
        }
        res.data.results.forEach((ot) => {
          if (ot.acciones == null) return
          ot.acciones.forEach((action) => {
            if (optionActionSelected && action !== optionActionSelected) {
              return
            }

            const actionObject = this.actions.find((a) => a[0] === action)
            if (!actionObject) return
            this.OTList.push({
              ot: ot.ot_id,
              action: actionObject,
              created_at: ot.created_at,
            })
            this.loading = false
          })
        })
      } catch (error) {
        console.error('Error al cargar notificaciones:', error)
      } finally {
        this.loading = false
      }
    },
    formatedDate(date) {
      return moment(date).format('DD/MM/YYYY H:mm')
    },
    formatDateDay(date) {
      return moment(date).format('DD MMM YYYY')
    },
    formatDateTime(date) {
      return moment(date).format('HH:mm [Hrs]')
    },
    async selectServiceType(type) {
      this.serviceTypeSelected = type
      await this.handleSelectedAction()
    },
    handleOutsideClick(event) {
      const bell = document.getElementById('popover-1-bottomleft')
      const popover = document.querySelector('.custom-notifications-popover')
      if (
        bell &&
        !bell.contains(event.target) &&
        (!popover || !popover.contains(event.target))
      ) {
        this.closeNotifications()
      }
    },
    closeNotifications() {
      this.$root.$emit('bv::hide::popover', 'popover-1-bottomleft')
    },
    async shakeBell() {
      const self = this
      self.animated = true
      setTimeout(() => {
        self.animated = false
      }, 1000)
    },
    async getNotifications() {
      this.newOT = 0
      this.optionActionSelected = ''
      this.stopFetch = false
      // Si es la primera vez que entra a las notificaciones
      if (this.currentPage === 1) {
        const res = await this.listNotificationsPagination({
          page: this.currentPage,
          action: '',
          tipo_servicio: '',
        })
        if (res.status < 200 || res.status >= 300) {
          return
        }

        this.OTList = []
        this.actionsAvailable = res.data.available_actions
          .filter((action) => this.actions.some((a) => a[0] === action))
          .map((action) => {
            const actionObject = this.actions.find((a) => a[0] === action)
            return { value: actionObject[0], text: actionObject[1] }
          })
        res.data.results.forEach((ot) => {
          if (ot.acciones == null) return
          ot.acciones.forEach((action) => {
            const actionObject = this.actions.find((a) => a[0] === action)
            if (!actionObject) return
            this.OTList.push({
              ot: ot.ot_id,
              action: actionObject,
              created_at: ot.created_at,
            })
            this.loading = false
            /*  const actionObject = this.actions.find((a) => a[0] === action)
          if (!actionObject) return
          this.OTList.push({ ot, action: actionObject })
          this.loading = false */
          })
        })
      }
    },
    initWebsockets() {
      this.socket = io(settings.webSocketsUrl)
      this.socket.on('order_added', () => {
        setTimeout(() => {
          this.newOT += 1
          this.shakeBell()
        }, 500)
      })
    },
  },
  watch: {
    optionActionSelected(_, oldValue) {
      this.previousOptionActionSelected = oldValue
      this.stopFetch = false
      this.OTList = []
      this.loading = true
    },
  },
  mounted() {
    window.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.handleOutsideClick)
  },
  computed: {
    ...mapGetters('OT', ['notificationsOTS']),
    ...mapGetters('AuthenticationStore', ['user']),
    formattedActions() {
      return this.actions.map(([value, text]) => ({ value, text }))
    },
  },
}
</script>
<style>
.bs-popover-right > .arrow,
.bs-popover-auto[x-placement^='right'] > .arrow {
  display: none !important;
}
#bell-dropdown-top-right .bell-icon {
  color: #1D4ED8 !important;
  font-size: 20px;
  vertical-align: middle;
}
.shake {
  animation: shake 0.62s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}
@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }
  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>
<style lang="scss" scoped>
.popover,
.b-popover {
  display: none;
  background: transparent !important;
  border: transparent !important;
}
.scroll {
  overflow-y: scroll;
  scroll-margin-top: 10px;
  scroll-margin-bottom: 10px;
}
.dropdown-content {
  display: block;
  position: absolute;
  background-color: white;
  width: 520px;
  box-shadow: -4px 6px 8px 0px rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(82, 82, 82, 0.5);
  border-radius: 0.5rem;
  top: 2rem;
  left: -460px; // Desktop alignment
  height: 650px;
  overflow-x: hidden;
  list-style-type: none;
  padding: 0;
  margin: 0;

  @media (max-width: 576px) {
    width: 90vw !important;
    max-width: 360px !important;
    left: -240px !important; // Approximating original centered position relative to right-aligned trigger
    top: 2.5rem !important;
    height: 70vh !important;
  }
}

::v-deep .custom-notifications-popover {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  max-width: none !important;
  z-index: 1060;

  .popover-body {
    padding: 0 !important;
  }
  .arrow {
    display: none !important;
  }
}

.close-icon {
  cursor: pointer;
  color: #23201c !important; // Explicit black color
  font-weight: bold;
  &:hover {
    color: #000 !important;
  }
}
.font-notification {
  font-weight: 700 !important;
  color: #23201c;
  font-size: 1.25rem;
}
.all-read {
  font-size: 0.5rem;
}
.title-notifications {
  word-wrap: break-word;
  background-color: #fff;
  width: auto;
  height: auto;
  padding: 1.25rem 1.25rem 0.5rem 1.25rem;
}
.custom-select-full {
  border: 1px solid #525252;
  border-radius: 5px;
  height: 45px;
  color: #525252;
}
.tabs-container {
  border-bottom: 1px solid rgba(82, 82, 82, 0.2);
}
.gap-16 {
  gap: 1.5rem;
}
.tab-item {
  cursor: pointer;
  padding: 0.5rem 0.5rem 0.75rem 0.5rem;
  border-bottom: 2px solid transparent;
  span {
    font-size: 1rem;
    font-weight: 700;
    color: #525252;
  }
}
.tab-item.active {
  border-bottom: 2px solid #1d4ed8;
  span {
    color: #1d4ed8;
  }
}
.notification-item {
  word-wrap: break-word;
  transition: background-color 0.2s;
  &:hover {
    background-color: #f8f9fa;
  }
}
.date-container {
  min-width: 100px;
  text-align: center;
}
.date-text {
  font-weight: 700;
  font-size: 1rem;
  color: #525252;
}
.time-text {
  font-size: 0.9375rem;
  color: #525252;
}
.ot-text {
  font-weight: 700;
  font-size: 1rem;
  color: #23201c;
}
.action-link {
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
.action-text {
  font-size: 1rem;
  color: #1d4ed8;
}
.separator-notification-item {
  border-bottom: 1px solid rgba(82, 82, 82, 0.2);
}
ul {
  padding-inline-start: 0px;
  margin-block-start: 0em;
  margin-block-end: 0em;
}
/* width */
::-webkit-scrollbar {
  width: 5px;
  border-radius: 0.5rem;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 0.5rem;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #d3d9e1;
  border-radius: 0.5rem;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #888;
}
a {
  color: #1d4ed8;
  cursor: pointer;
}
a:hover {
  color: #1d4ed8;
}
::v-deep .dropdown-item:active {
  background-color: transparent;
}
.title-notifications:hover {
  background-color: transparent;
}
.bold {
  font-weight: 700 !important;
}
.popover-notifications {
  display: block;
  position: absolute;
  width: 25px;
  border: 1px solid #1d4ed8;
  border-radius: 40%;
  height: 25px;
  top: -10px;
  z-index: 1;
  left: 20px;
  font-size: 0.7rem;
  background-color: #1d4ed8;
  color: white;
}
</style>
